import { writable } from "svelte/store";
import { ROOM_CONNECTION_STATE } from "../types/Room/RoomConnectionState";
export const roomStateStore = writable(ROOM_CONNECTION_STATE.IDLE);
